module.exports = __webpack_public_path__ + "static/media/julia.4fd3f3fc.svg";